"use client";

import type { Locale } from "@/i18n/locales";
import dynamic from "next/dynamic";

// Legacy stylesheet each country's CMS content was authored against. BR's
// (static/cms-br.css) also carries overrides for BR CMS keys. CO's is the whole
// Alice sheet scoped to the CMS wrappers — regenerate it with
// scripts/cms/snapshot-co-legacy-css.mjs, never by hand. CO has no mobile
// variant: m.dafiti.com.co is a separate app that does not render this
// content, so the desktop sheet serves every device, as BR's already does.
//
// One image serves every country, so a static import would ship both legacy
// sheets to every page. Behind next/dynamic each sheet is its own chunk, and
// during SSR Next emits a <link rel="stylesheet"> (from /_next/static, through
// the asset prefix) only for the chunk that is actually rendered. This must
// stay a client component: CSS of a client module imported statically by a
// server component lands in the route CSS whether or not it renders.
//
// No `loading` and no `ssr: false`: either one wraps the sheet in its own
// Suspense boundary, and client navigations would reveal the CMS content
// before the sheet loads. Without them, the navigation transition holds the
// previous page until the sheet's chunk (JS and CSS) is in.
const LEGACY_STYLES: Record<Locale, React.ComponentType> = {
  "pt-BR": dynamic(() => import("./LegacyStylesBR")),
  "es-CO": dynamic(() => import("./LegacyStylesCO")),
};

export function CMSLegacyStyles({ locale }: Readonly<{ locale: Locale }>) {
  const LegacyStyles = LEGACY_STYLES[locale];

  return <LegacyStyles />;
}
